module.exports = __webpack_public_path__ + "img/sft_logo.507b386f.svg";